import css from "./AboutPage.module.css";

export default function AboutPage() {
  return (
    <div className={css.container}>
      <h1 className={css.title}>Про нас</h1>
      <p className={css.description}>
        Клієнти, які звертаються до нашого дизельного сервісу з метою провести
        якісний ремонт форсунок, завжди отримують перше запитання: «Що
        відбувається з Машиною?». Це питання задається для того, щоб дізнатися,
        чи зможемо ми допомогти вирішити вашу проблему, а не просто
        відремонтувати форсунки. Часто буває так, що несправність машини полягає
        зовсім не в поломці форсунки, а через проблеми з іншими комплектуючими.
        Безперечно, форсунки також можуть потребувати ремонту, але не є
        першопричиною пошкодження. Ремонт дизельних форсунок допоможе вирішити
        вашу проблему.
      </p>
      <h2 className={css.text}>ЕТАПИ ДІАГНОСТИКИ ТА РЕМОНТУ ФОРСУНОК</h2>
      <p className={css.text}>
        Поломка форсунки може виникати за низкою факторів, через які ця деталь
        втрачає свої первісні властивості.
      </p>
      <h3 className={css.text}>Слід розділити роботу над форсунками на кілька етапів:</h3>
      <ul className={css.list}>
        <li className={css.listItem}>
          Початкове очищення форсунки за допомогою піскоструминного апарату та
          ультразвукової ванни;
        </li>
        <li className={css.listItem}>
          Перша діагностика. На стенді для перевірки та обчислення характеру
          можливих ушкоджень форсунки;
        </li>
        <li className={css.listItem}>
          Подальше обговорення пошкоджень із клієнтом та можливі способи
          вирішення проблеми;
        </li>
        <li className={css.listItem}>
          Розбирання, реставрація або заміна деталей форсунки для коректної
          роботи,
        </li>
        <li className={css.listItem}>Складання форсунки, регулювання зазорів;</li>
        <li className={css.listItem}>
          Фінальна діагностика на стенді для перевірки якості роботи форсунки,
          та кодування
        </li>
      </ul>
      <p className={css.text}>
        Ми намагаємося провести найбільш оптимальний та недорогий ремонт
        дизельних форсунок.
      </p>
    </div>
  );
}
